import Swal, { SweetAlertResult } from 'sweetalert2';

export class SaimyrAlerts {
    static toast = (Swal as any).mixin({
        toast:              true,
        position:   'bottom-end',
        showConfirmButton: false,
        timer:              4000,
        background:    '#F3F3F3',
    });

    static errorObligatoryFields() {
        Swal.fire({
            title: 'Error!',
            text: 'Falta llenar campos obligatorios',
            type: 'error',
            confirmButtonText: 'Ok',
            customClass: 'saimyrAlerts'
          });
    }

    static saved(mensaje: string) {
        SaimyrAlerts.toast({
            type: 'success',
            title: mensaje,
            customClass: 'saimyrAlerts'
          });
    }

    static errorSaving(mensaje: string) {
        SaimyrAlerts.toast({
            type: 'error',
            title: mensaje,
            customClass: 'saimyrAlerts'
        });
    }

    static errorCustomized(title: string, text: string, button: string) {
        Swal.fire({
            title: title,
            text: text,
            type: 'error',
            confirmButtonText: button,
            customClass: 'saimyrAlerts'
          });
    }

    static warningMessage(title: string, text: string, button: string) {
        Swal.fire({
            title: title,
            text: text,
            type: 'warning',
            confirmButtonText: button,
            customClass: 'saimyrAlerts'
          });
    }

    static InfoMessage(title: string, text: string, button: string) {
        Swal.fire({
            title: title,
            text: text,
            type: 'info',
            confirmButtonText: button,
            customClass: 'saimyrAlerts'
          });
    }

    static savedCustomized(title: string, text: string, button: string) {
        Swal.fire({
            title: title,
            text: text,
            type: 'success',
            confirmButtonText: button,
            customClass: 'saimyrAlerts'
          });
    }

    static confirmDelete(): Promise<SweetAlertResult> {
        return Swal.fire({
            title: 'Estas seguro?',
            text: 'No podrÃ¡s revertir esto!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, Borrar!',
            customClass: 'saimyrAlerts'
        });
    }
    static confirmCrearPersona(): Promise<SweetAlertResult> {
        return Swal.fire({
            title: 'Esta persona no existe!',
            text: 'Â¿Deseas crearla?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Aceptar',
            customClass: 'saimyrAlerts'
        });
    }

    static confirmWarning(title: string, text: string, confirmButton: string, cancelButton: string): Promise<SweetAlertResult> {
        return Swal.fire({
            title: title,
            text: text,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: confirmButton,
            cancelButtonText: cancelButton,
            customClass: 'saimyrAlerts'
        });
    }
}
